import React from "react";
import "./Profile.css";

function Profile() {
  const adminName = localStorage.getItem("name") || "Admin";
  const adminEmail = localStorage.getItem("email") || "admin@bibahobangla.com";
  const adminType = localStorage.getItem("AdminType") || "Administrator";
  const adminPhoto = localStorage.getItem("photo") || localStorage.getItem("adminPhoto");

  return (
    <div className="profile-container">
      <div className="profile-header">
        <h1 className="profile-title">Profile</h1>
        <p className="profile-subtitle">Manage your account information</p>
      </div>

      <div className="profile-content">
        <div className="profile-card">
          <div className="profile-avatar-section">
            <div className="profile-avatar-container">
              {adminPhoto ? (
                <img 
                  src={adminPhoto} 
                  alt="Profile" 
                  className="profile-avatar-image"
                />
              ) : (
                <span className="material-icons profile-avatar-icon">person</span>
              )}
            </div>
            <button className="profile-change-photo-btn">
              <span className="material-icons">camera_alt</span>
              Change Photo
            </button>
          </div>

          <div className="profile-form-section">
            <div className="profile-form-group">
              <label className="profile-label">Full Name</label>
              <input 
                type="text" 
                className="profile-input" 
                value={adminName}
                readOnly
                placeholder="Enter your full name"
              />
            </div>

            <div className="profile-form-group">
              <label className="profile-label">Email Address</label>
              <input 
                type="email" 
                className="profile-input" 
                value={adminEmail}
                readOnly
                placeholder="Enter your email"
              />
            </div>

            <div className="profile-form-group">
              <label className="profile-label">Role</label>
              <input 
                type="text" 
                className="profile-input" 
                value={adminType}
                readOnly
                placeholder="Your role"
              />
            </div>

            <div className="profile-form-group">
              <label className="profile-label">Phone Number</label>
              <input 
                type="tel" 
                className="profile-input" 
                placeholder="Enter your phone number"
                readOnly
              />
            </div>

            <div className="profile-actions">
              <button className="profile-save-btn" disabled>
                <span className="material-icons">save</span>
                Save Changes
              </button>
              <button className="profile-cancel-btn" disabled>
                Cancel
              </button>
            </div>
          </div>
        </div>

        <div className="profile-info-card">
          <h2 className="profile-info-title">Account Information</h2>
          <div className="profile-info-item">
            <span className="profile-info-label">Account Created:</span>
            <span className="profile-info-value">Coming Soon</span>
          </div>
          <div className="profile-info-item">
            <span className="profile-info-label">Last Login:</span>
            <span className="profile-info-value">Coming Soon</span>
          </div>
          <div className="profile-info-item">
            <span className="profile-info-label">Status:</span>
            <span className="profile-info-badge active">Active</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;

